export default "__VITE_ASSET__CnI$8L6B__"